import {
  AnalyticsService,
} from '@refx/analytics-core';
import {
  distinctUntilChanged,
  filter,
  from,
  map,
  switchMap,
} from 'rxjs';

/**
 * Returns an instance of the device detector service once the application has loaded
 *
 * @param analyticsService AnalyticsService
 * @returns DeviceDetectorService
 */
const getDeviceDetectorService = (analyticsService?: AnalyticsService) => analyticsService?.hasApplicationLoaded$.pipe(
  filter((hasLoaded) => hasLoaded),
  switchMap(() => from(analyticsService.getDeviceDetectorService())),
  distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b))
);

/**
 * Returns a method which takes the analytics service in parameter and returns the operating system derived from the user-agent.
 */
export const retrieveOperatingSystem = () =>
  (analyticsService?: AnalyticsService) =>
    getDeviceDetectorService(analyticsService)?.pipe(
      map((deviceDetector) => deviceDetector?.os),
      distinctUntilChanged()
    );

/**
 * Returns a method which takes the analytics service in parameter and returns the operating system version derived from the user-agent.
 */
export const retrieveOperatingSystemVersion = () =>
  (analyticsService?: AnalyticsService) =>
    getDeviceDetectorService(analyticsService)?.pipe(
      map((deviceDetector) => deviceDetector?.os_version),
      distinctUntilChanged()
    );

/**
 * Returns a method which takes the analytics service in parameter and returns the device type derived from the user-agent.
 */
export const retrieveDeviceType = () =>
  (analyticsService?: AnalyticsService) =>
    getDeviceDetectorService(analyticsService)?.pipe(
      map((deviceDetector) => deviceDetector?.deviceType),
      distinctUntilChanged()
    );
